export default {"src":"/_next/static/media/google-green.42d4a2d9.svg","height":33,"width":27,"blurWidth":0,"blurHeight":0};